import { Box, BoxProps } from "@chakra-ui/react";

export function EditIcon({ width, height, ...props }: BoxProps) {
	return (
		<Box cursor={'pointer'} {...props}>
			<svg
				width={`${width || '24'}`}
				xHeight={`${height || '37'}`}
				viewBox="0 0 24 37"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9.38251 13.09C9.8793 12.5517 10.1277 12.2826 10.3916 12.1256C11.0285 11.7468 11.8128 11.7351 12.4603 12.0946C12.7286 12.2435 12.9847 12.5051 13.4967 13.0282C14.0088 13.5513 14.2648 13.8128 14.4107 14.087C14.7626 14.7484 14.7511 15.5495 14.3803 16.2001C14.2266 16.4698 13.9631 16.7235 13.4362 17.231L7.16713 23.2692C6.16862 24.2309 5.66937 24.7118 5.04541 24.9555C4.42145 25.1992 3.73551 25.1813 2.36362 25.1454L2.17696 25.1405C1.75931 25.1296 1.55049 25.1241 1.4291 24.9864C1.30771 24.8486 1.32428 24.6359 1.35743 24.2104L1.37542 23.9794C1.46871 22.782 1.51536 22.1833 1.74918 21.6451C1.983 21.107 2.38633 20.67 3.19299 19.796L9.38251 13.09Z"
					stroke='currentColor'
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path
					d="M8.66675 13.166L13.3334 17.8327"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinejoin="round"
				/>
				<path
					d="M9.33337 25.166L14.6667 25.166"
					stroke="currentColor"
					strokeWidth="1.5"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</Box>
	);
}
